/**
 * Like it sounds like, reset field values to blank
 *
 * Used in Svelte forms, reactive assignment to clear field values when the form has  been sent
 *
 * @param {Object[]} fields - fields to clear
 */
function clearFieldValues(fields) {
  fields.forEach(field => (field.value = ''));
}

export default clearFieldValues;



// WEBPACK FOOTER //
// ./scripts/util/validation/clearFieldValues.js